import { useState } from 'react';
import styled from 'styled-components';
import { Box, Heading, Paragraph, Stack } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { spaces } from '@99designs/emu/settings';
import { Step } from './Step';
import { steps } from './steps';

const Wrapper = styled(Box)`
    margin: ${spaces.px['3bu']}px 0 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    ${mediaQuery.maximum('medium')} {
        margin: ${spaces.px['3bu']}px 0 0;
    }

    ${mediaQuery.maximum('small')} {
        flex-direction: column;
        margin: ${spaces.px['6bu']}px 0 0;
    }
`;

const StyledHeading = styled(Heading)`
    text-align: center;
`;

export function HowItWorks() {
    const [activeIndex, setActiveIndex] = useState<number>(0);

    const handleMouseEnter = (index: number) => {
        setActiveIndex(index);
    };

    const handleMouseLeave = () => {
        setActiveIndex(0);
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="center">
            <Stack space="1bu">
                <StyledHeading accessibilityLevel={2} appearanceLevel={1}>
                    {__('How it works')}
                </StyledHeading>
                <Paragraph size="large">{__('Level up your brand in 3 easy steps')}</Paragraph>
            </Stack>
            <Wrapper>
                {steps().map((step, index) => {
                    return (
                        <Step
                            key={index}
                            title={step.title}
                            body={step.body}
                            step={index + 1}
                            image={step.image}
                            onMouseEnter={() => handleMouseEnter(index)}
                            onMouseLeave={handleMouseLeave}
                            activeStep={activeIndex + 1}
                        />
                    );
                })}
            </Wrapper>
        </Box>
    );
}
